var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmgVariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M103.444 40.3036C103.165 39.7411 102.709 39.2341 102.709 39.2341C102.709 39.2341 102.656 27.8596 102.653 27.0991C102.65 26.3386 103.498 26.3386 103.498 26.3386V24.7471C103.498 24.7471 103.145 23.6206 102.935 22.5091C102.725 21.3961 103.498 20.3686 103.498 20.3686V17.5561C103.498 17.5561 102.046 16.8496 99.1746 15.9736C96.3036 15.0976 89.9271 15.1891 89.9271 15.1891L87.5616 14.3446H82.4931L81.4791 15.6391V16.5406L78.6066 16.5376L78.3246 14.6821H76.5786L74.4441 12.6691C74.4441 12.6691 71.6781 12.6826 71.6901 12.6691C71.7021 12.6556 70.0461 14.8516 70.0461 14.8516L67.9626 14.7946H40.5951L40.4256 11.5291L40.7631 10.5151L39.6936 9.61358H37.3281L32.6541 8.65658V1.88708H31.3596L30.7656 2.62658L30.0081 8.14958V10.7956L30.6426 11.7526L30.1776 15.2446H28.8261L26.4606 20.1436H24.2076L23.3061 19.2421H18.6321L17.4501 19.8121H16.3806L15.1416 19.2421L13.4001 19.6366V20.8936L14.1021 21.6646V22.8961L13.4001 23.8606V25.8226C13.4001 26.2636 15.0861 25.8226 15.0861 25.8226L15.6486 25.3261L17.8446 24.9316L18.3366 25.8226H23.8131C23.8131 25.8226 23.8131 26.3386 24.0036 27.1561C24.1941 27.9721 25.6716 30.9466 25.6716 30.9466L27.3051 30.5866L27.5001 31.5016C25.3296 33.0586 26.7531 35.9941 26.7531 35.9941L31.6986 51.2296L34.7391 52.5241L39.5826 50.7226L40.5966 47.6821L39.9546 46.0501L39.1701 45.2506L38.9076 43.5151L38.3451 42.2206L37.0506 41.7136C37.0506 41.7136 34.0791 34.8556 33.6156 33.6241C33.1521 32.3926 32.0616 31.5031 32.0616 31.5031L32.2881 30.0346L40.2621 30.0031L41.4996 29.4901L42.3591 30.3391L44.3721 30.3931L45.1041 30.6766C45.1041 30.6766 45.1896 33.7846 45.6276 35.0131C46.0656 36.2416 48.8766 36.2521 48.8766 36.2521H58.4946V38.8726C58.4946 38.8726 63.9471 49.8331 64.1931 50.0491C64.4406 50.2636 64.1931 55.0741 64.1931 55.0741C64.1931 55.0741 65.6571 57.1441 66.2196 58.1056C66.7821 59.0671 67.3911 58.8556 68.4096 58.8076C69.4281 58.7596 74.4411 56.0176 74.4411 56.0176L76.5816 55.5106L77.3706 54.4966L77.8206 55.1731L81.1986 53.3536C81.1986 53.3536 81.4176 52.4761 81.3921 52.1881C81.3666 51.9001 80.6256 50.3296 80.6256 50.3296L79.8471 50.2171L78.8901 48.4996L78.1296 46.4866L78.0246 45.4876L77.0946 44.9416L71.4711 37.1671L70.8066 35.5486C70.8066 35.5486 70.2726 31.8601 70.4976 30.9676C70.7226 30.0751 72.3726 28.5376 72.3726 28.5376L74.8896 28.3681L77.4801 28.7926L78.3816 27.9736L81.1971 27.4951L82.5201 32.0566L82.4916 41.2531L79.3941 44.2201L83.4606 51.3361L84.2901 51.6241L88.6281 49.2031H93.6396L98.2566 46.6021L98.9046 45.7231L100.292 45.4876L103.495 42.4471C103.495 42.4471 103.72 40.8706 103.441 40.3066L103.444 40.3036ZM19.8171 23.1286H19.2816V23.6356H16.8606V21.2851H19.1976V21.8911H19.8171V23.1301V23.1286ZM24.0051 23.6356H22.5051V21.2851H24.0051V23.6356ZM59.2911 31.5001V33.7156H58.4481C58.4481 33.7156 58.6716 35.0101 57.3756 35.0101H48.8721V33.9961C48.8721 33.9961 47.2956 34.3906 47.2956 32.8141V30.5206C47.2956 30.5206 47.4081 29.5486 48.4221 29.4361C49.4361 29.3236 53.8851 29.4361 53.8851 29.4361C53.8851 29.4361 53.9421 28.3096 55.7991 28.1416C57.6576 27.9721 58.8501 28.1416 58.8501 28.1416C58.8501 28.1416 60.0291 28.4821 59.9976 30.0016C59.9661 31.5211 59.2911 31.5016 59.2911 31.5016V31.5001ZM96.9006 46.1176H94.9162L92.6151 47.5741C92.6151 47.5741 92.0241 47.9746 91.3896 47.4046C90.7566 46.8346 91.5592 46.0471 91.5592 46.0471L94.0236 44.3836H96.9006V46.1146V46.1176Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1938 41.7675L35.1358 42.5565L34.6618 44.3865L35.4733 46.4415C35.4733 46.4415 36.3838 47.6805 34.6618 48.3L31.3633 49.6515",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4597 19.806V17.16H70.0477L70.2727 16.5405H73.6507C73.6507 16.5405 74.8897 16.428 74.8897 17.667V20.5455",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2642 38.8395H68.0772",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7283 41.0355H67.1203",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1924 43.2315H68.9219",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8816 45.4845H70.0486",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5562 47.3985H70.9497",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.241 56.553H67.3455L71.907 54.5505L72.4695 53.3115L73.878 52.749H76.6365L77.481 54.213",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6707 52.0725H73.2582L73.8207 51.6225H75.3972L76.0737 52.749",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0134 25.8225L83.7039 31.758H85.8579L86.9979 30H94.6419L95.4444 30.5205H98.7099",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7322 25.3245H91.5162L92.8677 26.6055H96.9012C96.9012 26.6055 98.5137 26.484 98.7102 28.065",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7322 34.377H86.6172L88.5177 37.164H98.7102",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.846 46.0485L83.367 48.567C83.367 48.567 83.7465 49.539 85.2675 48.8625C86.7885 48.1875 90.363 45.822 90.363 45.822L89.8275 44.9205H83.661L81.8445 46.0485H81.846Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7214 39.0645V40.6695L92.1509 42.444H94.9379L91.6019 38.8395L90.7214 39.0645Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3267 38.8395L96.2052 41.7675H97.0497V38.8395H93.3267Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4937 21.2145H93.6281",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5019 23.2695C27.3564 23.2695 27.5019 25.0005 27.5019 25.0005C27.5019 25.0005 28.7994 24.699 28.7994 25.821H40.9209V24.648H40.2309V23.5215H40.9209V22.458H28.8564C28.8564 22.458 28.8804 23.268 27.5034 23.268L27.5019 23.2695Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1094 23.4375H30.1794V24.846H31.1094V23.4375Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3975 23.4375H32.4675V24.846H33.3975V23.4375Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6849 23.4375H34.7549V24.846H35.6849V23.4375Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9727 23.4375H37.0427V24.846H37.9727V23.4375Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2598 23.4375H39.3298V24.846H40.2598V23.4375Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0935 28.2945V27.1545H39.6115V28.5345",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2878 13.797L31.3618 12.669H33.7408L35.0083 13.5975",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6443 11.3175H35.4728",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4008 29.4871H68.3723L66.2603 30.3361C66.2603 30.3361 65.4158 30.7021 65.4158 31.9696C65.4158 33.2371 66.5978 33.5746 67.3583 33.5746H70.3823",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2634 30C60.3894 30.027 60.9384 30 60.9384 30C60.9384 30 61.6569 30.1725 61.6569 29.487V28.38L66.2184 26.001",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9216 17.16V15.921V15.639",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0747 16.3185V15.189H78.1287",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8174 18.8565H63.4604",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9221 15.9209H44.6791C44.6791 15.9209 43.3381 15.7724 43.3381 16.6604H42.0496V18.0329H43.3801C43.3801 18.0329 43.2541 18.8564 44.3086 18.8564H50.2951",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3071 18.8565H29.4746V21.2835H32.0936V18.8565H33.6146V22.4595",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7549 19.1865H35.6849V18.8565H40.7654",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9008 20.7915H59.3618V22.3395H49.7468V20.7915H50.2253",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7468 18.06H50.4238V21.5655H51.7468V18.06Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2634 20.5455V23.016H67.8024V22.3395H68.4084V21.1575H65.3814V22.1505L68.4084 22.1295",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3814 21.1575H63.3474L62.8194 20.6295H60.2634",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7929 22.566H41.7654V23.2275H42.7929V22.566Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7929 24.2686H41.7654V24.9301H42.7929V24.2686Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5894 22.566H68.4089V23.2275H72.5894V22.566Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5894 24.2686H68.4089V24.9301H72.5894V24.2686Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0937 22.566H76.0662V23.2275H77.0937V22.566Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0937 24.2685H76.0662V24.93H77.0937V24.2685Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7012 23.2275H82.7322V22.566H89.1942L89.7012 23.2275Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7212 24.93H82.7322V24.2685H90.0672L90.7212 24.93Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6357 22.566H43.9902V23.2275H48.6357V22.566Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4602 24.2685H43.9902V24.93H66.4602V24.2685Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2888 30.5205V36.897",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1216 34.377H93.6286H92.7136V36.531H96.2896",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6287 36.531V34.377",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3367 31.7581V34.3771",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7875 30.7515C84.9863 30.7515 85.1475 30.5903 85.1475 30.3915C85.1475 30.1927 84.9863 30.0315 84.7875 30.0315C84.5887 30.0315 84.4275 30.1927 84.4275 30.3915C84.4275 30.5903 84.5887 30.7515 84.7875 30.7515Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5631 36.7304C85.7669 36.7304 85.9321 36.5652 85.9321 36.3614C85.9321 36.1576 85.7669 35.9924 85.5631 35.9924C85.3593 35.9924 85.1941 36.1576 85.1941 36.3614C85.1941 36.5652 85.3593 36.7304 85.5631 36.7304Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M94.221 24.852C94.279 24.852 94.326 24.805 94.326 24.747C94.326 24.689 94.279 24.642 94.221 24.642C94.163 24.642 94.116 24.689 94.116 24.747C94.116 24.805 94.163 24.852 94.221 24.852Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4284 27.4935C69.6463 27.4935 69.8229 27.3168 69.8229 27.099C69.8229 26.8811 69.6463 26.7045 69.4284 26.7045C69.2106 26.7045 69.0339 26.8811 69.0339 27.099C69.0339 27.3168 69.2106 27.4935 69.4284 27.4935Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8355 14.2185C72.968 14.2185 73.0755 14.1111 73.0755 13.9785C73.0755 13.846 72.968 13.7385 72.8355 13.7385C72.7029 13.7385 72.5955 13.846 72.5955 13.9785C72.5955 14.1111 72.7029 14.2185 72.8355 14.2185Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7319 16.758C82.852 16.758 82.9494 16.6606 82.9494 16.5405C82.9494 16.4204 82.852 16.323 82.7319 16.323C82.6118 16.323 82.5144 16.4204 82.5144 16.5405C82.5144 16.6606 82.6118 16.758 82.7319 16.758Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4669 9.96303C32.5663 9.96303 32.6469 9.88244 32.6469 9.78303C32.6469 9.68362 32.5663 9.60303 32.4669 9.60303C32.3675 9.60303 32.2869 9.68362 32.2869 9.78303C32.2869 9.88244 32.3675 9.96303 32.4669 9.96303Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4669 14.1585C32.5663 14.1585 32.6469 14.0779 32.6469 13.9785C32.6469 13.8791 32.5663 13.7985 32.4669 13.7985C32.3675 13.7985 32.2869 13.8791 32.2869 13.9785C32.2869 14.0779 32.3675 14.1585 32.4669 14.1585Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6442 34.8405C30.4138 34.8405 31.0377 34.2166 31.0377 33.447C31.0377 32.6774 30.4138 32.0535 29.6442 32.0535C28.8746 32.0535 28.2507 32.6774 28.2507 33.447C28.2507 34.2166 28.8746 34.8405 29.6442 34.8405Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6445 33.6209C29.7406 33.6209 29.8185 33.543 29.8185 33.4469C29.8185 33.3508 29.7406 33.2729 29.6445 33.2729C29.5484 33.2729 29.4705 33.3508 29.4705 33.4469C29.4705 33.543 29.5484 33.6209 29.6445 33.6209Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3611 49.6514L26.5746 35.4614C26.5746 35.4614 25.6266 33.0464 27.5016 31.4999C27.7701 31.2794 28.0956 31.0754 28.4886 30.8999C31.6416 29.4914 33.3876 33.2654 33.3876 33.2654L37.0476 41.7119L38.3421 42.2189L38.9046 43.5134V44.2454L39.2421 45.5399L39.8616 45.8219L40.5936 47.6804L39.5796 50.7209L34.7361 52.5224L31.6956 51.2279L31.3581 49.6514H31.3611Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5012 31.4999V30.3914L25.6727 30.9464C25.6727 30.9464 23.8142 28.1969 23.8142 26.3399C23.8142 24.4829 26.4602 20.1449 26.4602 20.1449",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4216 25.4939H18.0726V24.9314H15.6516V25.8224H13.4031V23.8604L14.1051 23.1584V21.6644L13.4031 21.2144V19.2434H15.4821L15.9321 19.8059H17.7336V19.2434H23.3091L24.2106 20.1449H26.4636L28.8291 15.2459H30.1806L30.4626 11.4734C30.4626 11.4734 29.9556 11.3609 30.0126 10.7984C30.0696 10.2359 30.0126 8.15239 30.0126 8.15239L30.8016 2.40889L31.3086 1.88989H32.6601V8.65639L37.3341 9.61339H39.6996V10.2884H40.9941V11.0144H39.8121V11.5274H40.4316V14.7929H68.1936L68.9256 15.4124V14.8499H70.4466V14.2304L71.7981 12.5414H74.2761L75.9096 13.7234H76.5846V14.6804H78.3306V16.5389H81.4836V15.2444L82.2156 14.3429H87.5646L89.8731 15.0749C89.8731 15.0749 91.9566 15.0749 94.1526 15.2444C96.3486 15.4139 99.5586 15.9194 101.248 16.5389C102.937 17.1584 103.501 17.5559 103.501 17.5559V20.3684C103.501 20.3684 102.826 21.1574 102.938 22.5089C103.051 23.8604 103.501 24.3104 103.501 24.3104V26.3369C103.501 26.3369 102.656 26.6189 102.656 26.9564C102.656 27.2939 102.713 39.2324 102.713 39.2324C102.713 39.2324 102.713 39.7394 103.051 39.8519C103.388 39.9644 103.501 40.2464 103.501 40.8659V42.4424C103.501 42.4424 100.291 45.8204 99.6156 45.8774C98.9406 45.9344 98.6586 45.4829 98.6586 45.4829L98.5461 46.4399L93.6471 49.1999H88.6356L83.7921 51.9029L79.4001 44.2169L82.0191 41.7674C82.0191 41.7674 82.2726 42.2744 82.4421 39.8249C82.6116 37.3754 82.5261 32.0534 82.5261 32.0534L81.0906 27.4919H80.1891L79.6266 27.9704H78.3876L77.8251 28.7024H76.0236L75.3486 28.3649H72.5886C72.5886 28.3649 70.2801 30.1109 70.2801 31.8569C70.2801 33.6029 70.6746 35.2349 70.6746 35.2349C70.6746 35.2349 71.1246 36.1364 71.0691 36.5864L76.9821 44.9204L77.7711 45.0329L78.3906 46.1024L77.9406 46.7774L79.8546 50.2124L80.4741 49.9874L81.3756 51.9014L81.4881 53.1959L77.8281 55.1669L77.3781 54.4919L76.3641 55.5059L74.4501 56.0129L68.6496 58.7159C68.6496 58.7159 66.7356 59.6729 65.6646 57.1394L64.0311 54.8309L64.2006 50.3264L58.4586 38.7824V37.1489L59.2446 36.9239V36.2489H47.8131C47.8131 36.2489 45.2226 36.0794 45.1671 33.3764L45.1101 30.6734L44.3781 30.3899H42.0126V29.4899H40.6611V29.9984H32.1021L32.0451 31.1789",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2966 30.5204C47.2966 30.5204 47.4091 29.5484 48.4231 29.4359C49.4371 29.3234 53.8861 29.4359 53.8861 29.4359C53.8861 29.4359 53.9431 28.3094 55.8001 28.1414C57.6586 27.9719 58.8511 28.1414 58.8511 28.1414C58.8511 28.1414 60.0301 28.4819 59.9986 30.0014C59.9671 31.5209 59.2921 31.5014 59.2921 31.5014V33.7169H58.4491C58.4491 33.7169 58.6726 35.0114 57.3766 35.0114H48.8731V33.9974C48.8731 33.9974 47.2966 34.3919 47.2966 32.8154V30.5219V30.5204Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8515 28.1399C58.8515 28.1399 57.659 27.9704 55.8005 28.1399V30.8999C55.8005 30.8999 55.688 32.4209 54.449 32.6459V33.7154C54.449 33.7154 55.913 34.3919 57.0395 32.8709H59.2925V31.4999C59.2925 31.4999 59.9675 31.5194 59.999 29.9999C60.0305 28.4804 58.8515 28.1399 58.8515 28.1399Z",
    fill: "#FAFAFB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2351 36.2489H64.0501L66.6406 34.8419H70.5826",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8162 26.3384H27.5017C27.5017 26.3384 28.9957 26.1134 29.8402 27.2399C30.6847 28.3664 31.0222 28.5344 31.0222 28.5344H39.8062V27.6899L41.6647 26.6204H52.1392L53.6482 26.0009H67.6252L68.3572 25.3259H70.1587L71.0602 25.8224H78.6622",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3262 16.5404V21.4394L78.8887 22.3964V27.9719",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0134 41.7674C82.0134 41.7674 83.1114 40.4159 84.2934 40.0214C85.4754 39.6269 86.3769 39.7394 86.3769 39.7394C86.3769 39.7394 87.0519 39.9089 88.1229 39.1769C89.1924 38.4449 89.5869 38.0504 89.5869 38.0504C89.5869 38.0504 89.7564 37.4879 92.0649 37.4879H98.2599",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3262 15.1889V20.1449L96.5152 24.5939C96.5152 24.5939 98.7112 24.5939 98.7112 27.1844V45.4859",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M81.479 16.5404V21.2144H82.493V25.8224H81.197V27.4919",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1794 15.2444V16.5404H31.9239V15.2444H34.7544",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8074 11.0159H36.2734L35.3869 11.6129C35.3869 11.6129 34.9639 16.3424 34.7539 17.6939C34.5424 19.0454 34.7539 21.6224 34.7539 21.6224H42.3559V20.5244L40.5964 19.8059V14.7944",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6326 19.8059H66.5556L68.4561 21.2834H72.7641V20.5454H78.1281",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5967 19.8059H49.5637",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8601 21.4679V23.6354H19.2811V23.1284H19.8166V21.8894H19.1971V21.2834H16.8601V21.4679Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0066 21.2834H22.5066V23.6339H24.0066V21.2834Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M96.901 44.3864V46.1174H94.9165L92.614 47.5739C92.614 47.5739 92.023 47.9744 91.3885 47.4044C90.7555 46.8344 91.558 46.0469 91.558 46.0469L94.0225 44.3834H96.8995L96.901 44.3864Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9742 44.9204L75.6782 45.7379L75.1712 47.0474L69.5972 50.2994L69.0902 49.6649L65.5847 49.5809L65.3312 50.2994L64.1912 50.3264",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmgVariant);
export default __webpack_public_path__ + "static/media/SMG Variant.4ff42bd47f9a68c83f7a2114e5ad9932.svg";
export { ForwardRef as ReactComponent };